import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { DefaultButton } from '@fluentui/react';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withErrorView } from '@bingads-webui-campaign-react/smart-page-error-boundary';
import { getLandingPageUrl } from '@bingads-webui-campaign-react/smart-page-util';

const getStyles = () => ({
  bannerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: 60,
    background: 'linear-gradient(102.36deg, #0A1B45 0%, #0A1B45 17.63%, rgba(27, 62, 115, 0.882169) 63.53%, rgba(43, 88, 156, 0.775808) 96.63%), #0A1B45',
    fontFamily: 'Segoe UI',
  },

  content: {
    display: 'flex',
    alignItems: 'center',
  },

  text: {
    marginRight: 52,
    height: 26,
    fontSize: 16,
    color: '#FFF',
  },

  strongFont: {
    fontWeight: 'bold',
  },

  mobileBannerContainer: {
    height: 90,

    '& $content': {
      flexDirection: 'column',
      justifyContent: 'center',
    },

    '& $text': {
      marginRight: 0,
      fontSize: 14,
    },

    '& button': {
      marginTop: 5,
      fontSize: 12,
    },
  },
});

const buttonStyles = {
  root: {
    background: 'transparent',
    fontSize: 14,
    lineHeight: 20,
    border: '1px solid #FFF',
    color: '#FFF',
  },
  rootHovered: {
    background: 'transparent',
    color: '#FFF',
  },
  rootPressed: {
    background: 'transparent',
    color: '#FFF',
  },
};

export const UnStyledSmartBannerView = ({
  classes,
  i18n,
  isMobile,
  customedContent,
}) => {
  const bannerContainerClasses = classnames({
    [classes.bannerContainer]: true,
    [classes.mobileBannerContainer]: isMobile,
  });

  const onClickButton = useCallback(() => {
    const landingPageUrl = getLandingPageUrl(document.domain, { source: 'm365banner' });

    window.open(landingPageUrl);
  }, []);

  return (
    <div className={bannerContainerClasses}>
      {
        customedContent || (
          <div className={classes.content}>
            <div className={classes.text}>
              <span>
                {i18n.getString(_TL_('This website is powered by'))}&nbsp;
                <span className={classes.strongFont}>Microsoft Advertising</span>
              </span>
            </div>
            <DefaultButton
              text={i18n.getString(_TL_('Create your website for free'))}
              styles={buttonStyles}
              onClick={onClickButton}
            />
          </div>
        )
      }
    </div>
  );
};

UnStyledSmartBannerView.propTypes = {
  classes: PropTypes.shape({
    bannerContainer: PropTypes.string.isRequired,
    mobileBannerContainer: PropTypes.string.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }),
  isMobile: PropTypes.bool.isRequired,
  customedContent: PropTypes.element,
};

UnStyledSmartBannerView.defaultProps = {
  i18n: {
    getString: key => key,
  },
  customedContent: null,
};

export const SmartBannerView = withErrorView(withDefaultStyles(
  UnStyledSmartBannerView,
  getStyles
), 'componentMode');
